// Libs
import React from 'react';
import { withRouter } from 'react-router-dom';
import { Container, Form } from 'react-bootstrap';
import Select from 'react-select';

// Services & Helpers
import GlobalStateService from 'services/GlobalStateService';
import BookingService from 'services/BookingService';
import LocationService from 'services/LocationService';
import VendorService from 'services/VendorService';
import CourseService from 'services/CourseService';

// Components
import Loader from 'components/common/Loader';
import BookingsTable from 'components/bookings/BookingsTable';
import EditBookingModal from 'components/bookings/EditBookingModal';
import PageHeader from 'components/common/PageHeader';
import SideBar from 'components/common/SideBar';

//-------------------------------------------------------------------------------------------------------------------

class EnquiriesPage extends React.Component {

    constructor(props) {
        super(props);

        this.editBookingModalRef = React.createRef();
        
        this.requestID = 1;
        this.state = {
            isLoadingFilters: true,
            isLoading: true,
            filters: {
                status: 'enquiry',
                orderBy: 'dateDesc',
                courseID: null,
                search: '',
                includeNonATP: true,
                includeATP: true
            }
        };
    }
    
    async componentDidMount() {
        window.scrollTo(0, 0);
        await this.loadFilters();
        this.load();
    }

    async loadFilters() {
        const courses = await CourseService.list();
        const geos = await LocationService.listGeos();
        const vendors = await VendorService.list();

        this.setState({
            courses,
            geos,
            vendors,
            isLoadingFilters: false
        });
    }
    
    async load() {
        GlobalStateService.setValues({
            area: 'enquiries'
        });
        this.requestID++;
        const enquiries = await BookingService.list(this.state.filters);
        this.setState({
            enquiries,
            isLoading: false
        });
    }

    async exportToExcel() {
        await BookingService.excel(this.state.filters, true);
    }

    debounceLoad() {
        clearTimeout(this.searchTimeout);
        this.searchTimeout = setTimeout(() => {
            this.load();
        }, 200);
    }

    updateFilter(name, value) {
        const filters = { ...this.state.filters };
        filters[name] = value;
        this.setState({
            filters
        }, () => {

            switch (name) {
                case 'courseID':
                case 'vendorID':
                case 'geoID':
                case 'isArchived':
                    this.load();
                    break;
                case 'search':
                    this.debounceLoad();
                    break;
            }

        });
    }

    async editEnquiry(enquiry) {
        await this.editBookingModalRef.current.show({
            bookingID: enquiry.id
        });
        this.load();
    }

    async addEnquiry() {
        await this.editBookingModalRef.current.show({
            status: 'Enquiry'
        });
        this.load();
    }
    
    render() {
        const {
            isLoading
        } = this.state;

        return (
            <div className="page enquiries-page full-width-page">

                <PageHeader hasSideBar>
                    <h1>Enquiries</h1>

                    <div className="buttons">

                        <button className="btn btn-primary" onClick={e => this.addEnquiry()}>
                            <span className="fa-solid fa-plus" />{' '}
                            New enquiry
                        </button>

                        <button className="btn btn-primary" onClick={e => this.exportToExcel()} disabled={isLoading}>
                            <span className="fa-solid fa-file-excel" />{' '}
                            Export
                        </button>

                    </div>
                </PageHeader>

                <main>

                    <SideBar content={this.renderSideBarContent()} />

                    <Container fluid>

                        <section>

                            {this.renderInner()}

                        </section>

                    </Container>

                </main>

            </div>
        );
    }

    renderSideBarContent() {
        const {
            isLoadingFilters,
            courses,
            filters
        } = this.state;

        if (isLoadingFilters) {
            return (<Loader />);
        }

        const vendors = [{ id: '', name: '(All)' }].concat(this.state.vendors);
        const geos = [{ id: '', name: '(All)' }].concat(this.state.geos);
        
        return (<>

            <Form.Group className="mb-3">
                <Form.Label>Search</Form.Label>
                <input
                    className="form-control"
                    type="search"
                    value={filters.search}
                    onChange={e => this.updateFilter('search', e.target.value)}
                />
                <div className="alert alert-info form-group-info">
                    Search by course, customer, instructor, language, location or reference...
                </div>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Course</Form.Label>
                <select
                    className="form-control"
                    value={filters.courseID || ''}
                    onChange={e => this.updateFilter('courseID', e.target.value)}
                >
                    <option value="">(All courses)</option>
                    {courses.map(c =>
                        <option key={c.id} value={c.id}>{c.name}</option>
                    )}
                </select>
            </Form.Group>


            <Form.Group className="mb-3">
                <Form.Label>Geo</Form.Label>
                <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    value={geos.find(g => g.id == filters.geoID)}
                    options={geos}
                    getOptionValue={g => g.id}
                    getOptionLabel={g => g.name}
                    onChange={g => this.updateFilter('geoID', g.id)}
                    placeholder="(All)"
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Vendor</Form.Label>
                <Select
                    className="react-select-container"
                    classNamePrefix="react-select"
                    value={vendors.find(v => v.id == filters.vendorID)}
                    options={vendors}
                    getOptionValue={v => v.id}
                    getOptionLabel={v => v.name}
                    onChange={v => this.updateFilter('vendorID', v.id)}
                    placeholder="(All)"
                />
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label>Archive status</Form.Label>
                <select
                    className="form-control"
                    value={filters.isArchived || ''}
                    onChange={e => this.updateFilter('isArchived', (e.target.value == 'true'))}
                >
                    <option value="">Active</option>
                    <option value="true">Archived</option>
                </select>
            </Form.Group>

        </>);
    }

    renderInner() {
        const {
            isLoading,
            enquiries
        } = this.state;

        if (isLoading) {
            return (<Loader />);
        }

        return (<>

            <BookingsTable
                mode="enquiries"
                isScrolling
                isEditMode
                requestID={this.requestID}
                bookings={enquiries}          
                onClick={async (booking) => {
                    await this.editEnquiry(booking);
                }}
            />

            <EditBookingModal ref={this.editBookingModalRef} />

        </>);
    }
}

export default withRouter(EnquiriesPage);